import React from 'react';
import { useWatch } from 'react-hook-form';
import { useExpenseReceiptTypeIdInputQuery } from '../../../../../../../services';
import { RhCheckbox } from '../../../../../../dum';
import { IExpense, REQUIRE_SUPPLEMENT } from '../expense-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../helpers';

// A receipt type that does not apply tax cannot carry a complemento, so the
// requirement is turned off and locked. Until a receipt is picked we treat it as
// taxable so nothing is disabled prematurely.
export function ExpenseRequireSupplementInput() {
    const receiptTypeId = useWatch({
        name: 'receipt_type_id',
    }) as IExpense['receipt_type_id'];
    const { data } = useExpenseReceiptTypeIdInputQuery();

    const receiptType = (data?.getReceiptTypes ?? []).find(
        (type) => type.id === receiptTypeId,
    );
    const appliesTax = receiptType ? receiptType.applies_tax : true;

    return (
        <RhCheckbox
            name={REQUIRE_SUPPLEMENT}
            label={shortLabel(FIELD_LABELS.require_supplement)}
            disabled={!appliesTax}
        />
    );
}
